import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "contact",
  class: "relative py-20"
}
const _hoisted_2 = { class: "relative z-10 container mx-auto px-4" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4 p-3 bg-red-500/80 text-white rounded text-center"
}
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row justify-center gap-4" }
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createCommentVNode(" Background image "),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "absolute inset-0 z-0" }, [
      _createElementVNode("img", {
        src: "/images/contact-bg.webp",
        alt: "Background",
        class: "w-full h-full object-cover object-bottom"
      }),
      _createElementVNode("div", { class: "absolute inset-0 bg-black/50" })
    ], -1 /* CACHED */)),
    _createCommentVNode(" Content "),
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-center text-white mb-12" }, " Pour nous contacter ", -1 /* CACHED */)),
      _createElementVNode("form", {
        class: "max-w-3xl mx-auto",
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createCommentVNode(" Error message "),
        ($data.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($data.errorMessage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" Name "),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.form.name) = $event)),
              type: "text",
              placeholder: "Nom / Name *",
              class: "w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.name]
            ])
          ]),
          _createCommentVNode(" Establishment "),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.form.establishment) = $event)),
              type: "text",
              placeholder: "Établissement / Society",
              class: "w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.establishment]
            ])
          ]),
          _createCommentVNode(" Phone "),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.form.phone) = $event)),
              type: "tel",
              placeholder: "Téléphone / Phone number *",
              class: "w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.phone]
            ])
          ]),
          _createCommentVNode(" Email "),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.form.email) = $event)),
              type: "email",
              placeholder: "Email *",
              class: "w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.email]
            ])
          ]),
          _createCommentVNode(" City "),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.form.city) = $event)),
              type: "text",
              placeholder: "Ville / City",
              class: "w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.city]
            ])
          ]),
          _createCommentVNode(" Availability "),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.form.availability) = $event)),
              type: "text",
              placeholder: "Disponibilité / Free Time",
              class: "w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.availability]
            ])
          ])
        ]),
        _createCommentVNode(" Buttons "),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = (...args) => ($options.downloadCatalogue && $options.downloadCatalogue(...args))),
            class: "bg-gascon-gold text-gascon-blue px-8 py-3 font-semibold hover:opacity-90 hover:cursor-pointer transition-opacity rounded",
            disabled: $data.loading
          }, _toDisplayString($data.loading ? 'Envoi en cours...' : 'Obtenir le catalogue !'), 9 /* TEXT, PROPS */, _hoisted_6),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = (...args) => ($options.openMailto && $options.openMailto(...args))),
            class: "border-2 border-white text-white px-8 py-3 font-semibold hover:bg-white hover:text-gascon-blue hover:cursor-pointer transition-colors rounded"
          }, " Discuter ! ")
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}